// Code generated by Slice Machine. DO NOT EDIT.

import dynamic from 'next/dynamic';

export const components = {
    banner: dynamic(() => import('./Banner')),
    before_and_after: dynamic(() => import('./BeforeAndAfter')),
    blog_before_and_after: dynamic(() => import('./BlogBeforeAndAfter')),
    blog_content: dynamic(() => import('./BlogContent')),
    blog_hero: dynamic(() => import('./BlogHero')),
    blog_reading_time: dynamic(() => import('./BlogReadingTime')),
    blog_recent_posts_list: dynamic(() => import('./BlogRecentPostsList')),
    blog_references: dynamic(() => import('./BlogReferences')),
    blog_related_posts: dynamic(() => import('./BlogRelatedPosts')),
    blog_reviewed_posts: dynamic(() => import('./BlogReviewedPosts')),
    bmi_calculator: dynamic(() => import('./BmiCalculator')),
    bmr_calculator: dynamic(() => import('./BmrCalculator')),
    button: dynamic(() => import('./Button')),
    button_section: dynamic(() => import('./ButtonSection')),
    calorie_calculator: dynamic(() => import('./CalorieCalculator')),
    collapsible_content: dynamic(() => import('./CollapsibleContent')),
    columns: dynamic(() => import('./Columns')),
    companies_logos: dynamic(() => import('./CompaniesLogos')),
    comparison_cards: dynamic(() => import('./ComparisonCards')),
    comparison_table_row: dynamic(() => import('./ComparisonTableRow')),
    comparison_tablev2: dynamic(() => import('./ComparisonTablev2')),
    cvps: dynamic(() => import('./Cvps')),
    divider: dynamic(() => import('./Divider')),
    doctor_review: dynamic(() => import('./DoctorReview')),
    doctors_info: dynamic(() => import('./DoctorsInfo')),
    doctors_info_card: dynamic(() => import('./DoctorsInfoCard')),
    fact_content_accordion: dynamic(() => import('./FactContentAccordion')),
    fact_content_graphs: dynamic(() => import('./FactContentGraphs')),
    facts: dynamic(() => import('./Facts')),
    faq: dynamic(() => import('./Faq')),
    feature_content: dynamic(() => import('./FeatureContent')),
    footer_banner: dynamic(() => import('./FooterBanner')),
    header_and_cta: dynamic(() => import('./HeaderAndCta')),
    hero: dynamic(() => import('./Hero')),
    hero_banner: dynamic(() => import('./HeroBanner')),
    hero_card: dynamic(() => import('./HeroCard')),
    hero_product: dynamic(() => import('./HeroProduct')),
    hero_productv2: dynamic(() => import('./HeroProductv2')),
    how_it_works: dynamic(() => import('./HowItWorks')),
    hubspot_form: dynamic(() => import('./HubspotForm')),
    image_and_content: dynamic(() => import('./ImageAndContent')),
    image_content: dynamic(() => import('./ImageContent')),
    image_content_contained: dynamic(() => import('./ImageContentContained')),
    key_takeaways: dynamic(() => import('./KeyTakeaways')),
    list: dynamic(() => import('./List')),
    options_cards: dynamic(() => import('./OptionsCards')),
    pricing_column: dynamic(() => import('./PricingColumn')),
    reasons_to_choose: dynamic(() => import('./ReasonsToChoose')),
    reviews: dynamic(() => import('./Reviews')),
    reviews_tab: dynamic(() => import('./ReviewsTab')),
    section_before_and_after: dynamic(() => import('./SectionBeforeAndAfter')),
    section_timeline: dynamic(() => import('./SectionTimeline')),
    section_timelinev2: dynamic(() => import('./SectionTimelinev2')),
    section_with_products: dynamic(() => import('./SectionWithProducts')),
    section_with_productsv2: dynamic(() => import('./SectionWithProductsv2')),
    social_media_share: dynamic(() => import('./SocialMediaShare')),
    step_cards: dynamic(() => import('./StepCards')),
    table_with_columns: dynamic(() => import('./TableWithColumns')),
    tag: dynamic(() => import('./Tag')),
    tag_content: dynamic(() => import('./TagContent')),
    testimonials: dynamic(() => import('./Testimonials')),
    text: dynamic(() => import('./Text')),
    usp_bar_slice: dynamic(() => import('./UspBarSlice')),
    usp_with_three_columns: dynamic(() => import('./SectionWithColumns')),
};
